import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { getRoleName, validArray } from 'utils';
import { useAuthState } from 'context/AuthContext';
import { useAppState } from 'context/AppContext';
import PageHeader from 'components/PageHeader';

function AuthRoute({
  component,
  children,
  exact,
  path,
  permissions,
}) {
  const { defaultOrganisation } = useAuthState();
  const { roles } = defaultOrganisation || [];
  const { applicationStatus } = useAppState();
  const roles1 = validArray(roles) && roles.map(getRoleName) || [];

  function getRole() {
    function checkRole(role) {
      if (permissions) {
        return permissions.includes(role);
      }
      return false;
    }
    return validArray(permissions) && roles1.some(checkRole);
  }
  const validRole = getRole();
  
  if (applicationStatus !== 'Live') {
    return (
      <PageHeader
        heading="We'll be back soon!"
        subHeading="Sorry for the inconvenience but we're performing some maintenance at the moment."
      />
    );
  }
 
  return (
    <>
      {!validRole && validArray(permissions) ? (
        <Redirect to="/unauthorised" />
      ) : (
        <Route exact={exact} path={path} component={component}>
          { children }
        </Route>
      )}
    </>
  )
}

AuthRoute.defaultProps = {
  exact: false,
  permissions: [],
}

export default AuthRoute;
